// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@sc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

promotionCodeFormStyles.applyButton = {
    css: css`
        margin-top: 22px;
        width: 100%;
    `,
};
promotionCodeFormStyles.title = {
    variant: "h5",
    forwardAs: "p",
};

promotionCodeFormStyles.removeCodeTag = {};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: 14,
};

promotionCodeFormStyles.promotionRemovedText = {
    size: 14,
};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: 14,
};
promotionCodeFormStyles.applyPromotionGridItem = {
    css: css`
        display: flex;

        &&& {
            min-width: 101px;
            ${xScreen("lte", "md")} {
                min-width: 122px;
            }
            ${xScreen("lte", 767)} {
                min-width: 112px;
            }

            flex-basis: auto;
        }
    `,
};
promotionCodeFormStyles.promotionCodeGridItem = {
    css: css`
        &&& {
            flex-grow: 1;
            max-width: unset;
            flex-basis: auto;
            max-width: calc(100% - 101px);
            ${xScreen("lte", "md")} {
                max-width: calc(100% - 122px);
            }
            ${xScreen("lte", 767)} {
                max-width: calc(100% - 112px);
            }
        }
    `,
};
promotionCodeFormStyles.promotionCodeTextField = {
    labelProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

promotionCodeFormStyles.gridContainer = { gap: 12 };
